import styled from 'styled-components';

export const DeleteModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;
